// ENGENDRÉ PAR scripts/make_logo_assets.ts — NE PAS MODIFIER À LA MAIN.
//
// La marque de getperimetr, relevée au navigateur sur getperimetr.com (le site est rendu côté
// client, donc son balisage n'existe qu'après exécution). Vingt-deux courbes qui forment un
// disque rayé.
//
// COPIÉE, PAS REDESSINÉE. Les attributs d'animation au repos (`pathLength`, `stroke-dasharray`)
// sont gardés : mesuré, les retirer change 216 pixels sur 48 360 — l'anticrénelage des bouts
// arrondis. Invisible, et gardé quand même.
//
// Les fichiers public/logo.svg et public/favicon.svg sortent de CES MÊMES données, et
// lib/logo_mark_parity.test.ts les tient d'accord.

/** Le repère du dessin. Les deux fichiers et le composant l'emploient. */
export const LOGO_VIEWBOX = "0 0 100 100";

/** Les attributs de trait, tels que le site les pose sur chacune des 22 courbes. */
export const LOGO_STROKE = {
  stroke: "currentColor",
  strokeWidth: 2.2,
  strokeLinecap: "round",
  fill: "none",
  opacity: 1,
  pathLength: 1,
  strokeDashoffset: "0px",
  strokeDasharray: "1px 1px",
} as const;

/** Les 22 courbes, de haut en bas. */
export const LOGO_D: readonly string[] = [
  "M 42.537594221700346 15 Q 50 14.563498289126768 57.462405778299654 15",
  "M 32.65965686614015 18.333333333333332 Q 50 18.27892766332459 67.34034313385985 18.333333333333332",
  "M 27.17046868637028 21.666666666666668 Q 50 21.080666385127973 72.82953131362972 21.666666666666668",
  "M 23.219643392964315 25 Q 50 25.333693784411423 76.78035660703569 25",
  "M 20.189137885663218 28.333333333333336 Q 50 27.955467377887782 79.81086211433679 28.333333333333336",
  "M 17.817900938565238 31.666666666666668 Q 50 31.194976378785164 82.18209906143477 31.666666666666668",
  "M 15.967846086384718 35 Q 50 35.09383039379054 84.03215391361528 35",
  "M 14.557264496091726 38.333333333333336 Q 50 38.76292642011503 85.44273550390827 38.333333333333336",
  "M 13.535119635462948 41.66666666666667 Q 50 41.69828596895803 86.46488036453705 41.66666666666667",
  "M 12.869318616540305 45 Q 50 45.46771601161266 87.13068138345969 45",
  "M 12.540855589055425 48.333333333333336 Q 50 47.628422910156274 87.45914441094457 48.333333333333336",
  "M 12.540855589055425 51.66666666666667 Q 50 52.31280204674873 87.45914441094457 51.66666666666667",
  "M 12.869318616540305 55 Q 50 55.25385579923955 87.13068138345969 55",
  "M 13.535119635462948 58.333333333333336 Q 50 58.43133351230785 86.46488036453705 58.333333333333336",
  "M 14.557264496091726 61.66666666666667 Q 50 62.372878440702955 85.44273550390827 61.66666666666667",
  "M 15.967846086384718 65 Q 50 64.49289413916682 84.03215391361528 65",
  "M 17.817900938565238 68.33333333333334 Q 50 68.40733252405101 82.18209906143477 68.33333333333334",
  "M 20.189137885663218 71.66666666666667 Q 50 72.0373155685855 79.81086211433679 71.66666666666667",
  "M 23.219643392964315 75 Q 50 74.87404147279283 76.78035660703569 75",
  "M 27.17046868637028 78.33333333333334 Q 50 78.31871731471604 72.82953131362972 78.33333333333334",
  "M 32.65965686614015 81.66666666666667 Q 50 81.00418219394787 67.34034313385985 81.66666666666667",
  "M 42.537594221700346 85 Q 50 84.73448147902553 57.462405778299654 85",
];
